import { FC } from 'react';
import Routes from '@/router/Routes.ts';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext.tsx';

const HomePage: FC = () => {
  const { isAdmin, isManager } = useAuthContext();

  return isAdmin ? (
    <Navigate to={Routes.ADMIN__DASHBOARD} />
  ) : isManager ? (
    <Navigate to={Routes.MANAGER__DASHBOARD} />
  ) : null;
};

export default HomePage;
